import StartPoint from "./StartPoint.png";

export default StartPoint;
